import { render, staticRenderFns } from "./QuizResultModal.vue?vue&type=template&id=77d39b1a&scoped=true&"
import script from "./QuizResultModal.vue?vue&type=script&lang=ts&"
export * from "./QuizResultModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d39b1a",
  null
  
)

export default component.exports